// The API sends a time of day (`TimeString`) as "HH:MM:SS"; every screen and time input shows "HH:MM".
export const formatClockTime = (time: string): string => time.split(':').slice(0, 2).join(':');

export const formatClockTimeRange = (start: string, end: string): string =>
  `${formatClockTime(start)}–${formatClockTime(end)}`;
